import { useQuery } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { ManagerSalaryResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  managerId: number;
  month: number;
  year?: number;
  order_by?: string;
  order_direction?: string;
  limit?: number;
  page?: number;
  export_xlsx?: boolean;
}

export const getManagersSalary = async (
  params: Params
): Promise<ManagerSalaryResponse> => {
  const {
    managerId,
    month,
    year,
    order_by,
    order_direction,
    limit,
    page,
  } = params;

  const { data } = await api.get<ManagerSalaryResponse>(
    `${BI_BASE_URL}/managers/manager/${managerId}/pay/${month}`,
    {
      params: {
        year: year ?? new Date().getFullYear(),
        order_by: order_by ?? 'hashrate',
        order_direction: order_direction ?? 'desc',
        limit: limit ?? 10,
        page: page ?? 1,
      },
    }
  );

  return {
    items: data?.items ?? [],
    total_pages: data?.total_pages ?? 0,
    total_items: data?.total_items ?? 0,
    current_page: data?.current_page ?? 1,
  };
};

export const useGetManagersSalary = (params?: Params) => {
  return useQuery({
    queryKey: [
      QUERY_KEY_MANAGER_PERFORMANCE.MANAGERS_SALARY,
      params?.managerId,
      params?.month,
      params?.year,
      params?.order_by,
      params?.order_direction,
      params?.page,
      params?.limit,
    ],
    queryFn: () => getManagersSalary(params!),
    enabled: !!params?.managerId && !!params?.month,
  });
};
